import React from 'react';

import { getService } from '../shell';

interface Transformation {
  [key: string]: any;
  height?: string;
  width?: string;
  dpr?: string;
  crop?: string;
  default_image?: string;
}

export interface ClImageProps
  extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  publicId: string;

  /**
   * Automatically apply DPR transformation based on device
   */
  autoDPR?: boolean;
  transformation?: Transformation;
}

export const ClImage: React.FC<ClImageProps> = ({
  publicId,
  autoDPR,
  transformation,
  ...rest
}) => {
  return (
    <img
      {...rest}
      style={{
        display: 'block',
        objectFit: 'cover',
        objectPosition: 'center center',
        ...rest.style,
        width: rest.style?.width || rest.width,
        height: rest.style?.height || rest.height,
      }}
      src={getCloudinarySrc({
        publicId,
        transformation: autoDPR
          ? {
              ...transformation,
              dpr: document.documentElement.classList.contains('hidpi')
                ? '2.0'
                : '1.0',
            }
          : transformation,
      })}
    />
  );
};

export function getCloudinarySrc({
  publicId,
  transformation,
}: {
  publicId?: string;
  transformation?: Transformation;
}): string {
  const cloudinary = getService('cloudinary');

  return (
    cloudinary
      .url(publicId, {
        transformation,
      })
      // enforce https. Maybe this can be configured in a better way but one
      // should read the docs for angular cloudinary component which makes no sense at the moment
      .replace('http:', 'https:')
  );
}
